import { render, staticRenderFns } from "./modal-edit-property.vue?vue&type=template&id=497c414a&scoped=true&"
import script from "./modal-edit-property.vue?vue&type=script&lang=js&"
export * from "./modal-edit-property.vue?vue&type=script&lang=js&"
import style0 from "./modal-edit-property.vue?vue&type=style&index=0&id=497c414a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c414a",
  null
  
)

export default component.exports